import Hades from '@adoratorio/hades';
import loop from '@/scripts/loop';

const scrollbar = {
  ref: null,
  init: () => {
    scrollbar.ref = new Hades({
      mode: Hades.MODE.VIRTUAL,
      viewport: document.querySelector('.app__wrapper'),
      container: document.querySelector('.app__container'),
      easing: {
        mode: Hades.EASING.QUAD,
        duration: 800,
      },
      touchMultiplier: 3,
      autoBoundries: true,
      smoothDirectionChange: true,
      aion: loop,
      scrollbar: null,
    });
  },
};

export default scrollbar;
